import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    projectType: 'T-Shirts'
  });

  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: null
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, submitted: false, error: null });

    try {
      // Send admin notification
      await emailjs.send(
        'service_l3m3m0p',
        'template_contact_form',
        {
          from_name: formData.name,
          from_email: formData.email,
          company: formData.company || 'N/A',
          project_type: formData.projectType,
          message: formData.message,
          to_email: 'highlinehoodies@gmail.com'
        },
        'B-OLwAMJiQ94ehf7y'
      );

      // Send customer confirmation
      await emailjs.send(
        'service_l3m3m0p',
        'template_customer_confir',
        {
          from_name: formData.name,
          from_email: formData.email,
          project_type: formData.projectType,
          message: formData.message,
          year: new Date().getFullYear()
        },
        'B-OLwAMJiQ94ehf7y'
      );
      
      setFormData({
        name: '',
        email: '',
        company: '',
        message: '',
        projectType: 'T-Shirts'
      });
      setStatus({ submitting: false, submitted: true, error: null });
    } catch (error) {
      console.error('Submission error:', error);
      setStatus({ 
        submitting: false, 
        submitted: false, 
        error: 'Failed to send message. Please try again.' 
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="bg-gray-900 py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-magenta-500">Contact Us</h1>
          <p className="mt-4 text-xl text-gray-300">
            Let's discuss your custom apparel needs
          </p>
        </div>

        {status.submitted ? (
          <div className="bg-green-500/10 border border-green-500 rounded-xl p-8 text-center">
            <h3 className="text-xl font-bold text-green-500 mb-2">Thank You!</h3>
            <p className="text-gray-300">
              We've received your message and will get back to you soon.
            </p>
            <button
              onClick={() => setStatus({ submitted: false, submitting: false, error: null })}
              className="mt-4 px-6 py-2 bg-magenta-500 text-black rounded-lg hover:bg-magenta-400 transition-colors"
            >
              Send Another Message
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-8 bg-gray-800 p-8 rounded-xl">
            {status.error && (
              <div className="bg-red-500/10 border border-red-500 rounded-lg p-4 text-red-500">
                {status.error}
              </div>
            )}

            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  disabled={status.submitting}
                  className="block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-magenta-500 focus:ring-magenta-500 disabled:opacity-50 px-4 py-3"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  disabled={status.submitting}
                  className="block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-magenta-500 focus:ring-magenta-500 disabled:opacity-50 px-4 py-3"
                />
              </div>
            </div>

            <div>
              <label htmlFor="company" className="block text-sm font-medium text-gray-300 mb-2">
                Company Name
              </label>
              <input
                type="text"
                name="company"
                id="company"
                value={formData.company}
                onChange={handleChange}
                disabled={status.submitting}
                className="block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-magenta-500 focus:ring-magenta-500 disabled:opacity-50 px-4 py-3"
              />
            </div>

            <div>
              <label htmlFor="projectType" className="block text-sm font-medium text-gray-300 mb-2">
                Project Type
              </label>
              <select
                name="projectType"
                id="projectType"
                value={formData.projectType}
                onChange={handleChange}
                disabled={status.submitting}
                className="block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-magenta-500 focus:ring-magenta-500 disabled:opacity-50 px-4 py-3"
              >
                <option>T-Shirts</option>
                <option>Hoodies</option>
                <option>Hats</option>
                <option>Multiple Items</option>
                <option>Other</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">
                Message
              </label>
              <textarea
                name="message"
                id="message"
                rows={4}
                required
                value={formData.message}
                onChange={handleChange}
                disabled={status.submitting}
                className="block w-full rounded-md bg-gray-700 border-gray-600 text-white shadow-sm focus:border-magenta-500 focus:ring-magenta-500 disabled:opacity-50 px-4 py-3"
                placeholder="Tell us about your project..."
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={status.submitting}
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-cyan-500 hover:bg-cyan-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {status.submitting ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}